// 端末の時計のずれを get_state の server_time で補正する（残り時間の表示用）
let offsetMs = 0;

export function syncServerTime(serverIso: string, sentAt: number, receivedAt: number): void {
  const server = Date.parse(serverIso);
  if (Number.isNaN(server)) return;
  offsetMs = server - (sentAt + receivedAt) / 2;
}

/** サーバーの時刻での「今」（ミリ秒） */
export function serverNow(): number {
  return Date.now() + offsetMs;
}

/** 期限までの残り（ミリ秒、0未満は0） */
export function remainingMs(untilIso: string | null | undefined): number {
  if (!untilIso) return 0;
  return Math.max(0, Date.parse(untilIso) - serverNow());
}

/** m:ss（1時間以上は h:mm:ss） */
export function fmtRemaining(ms: number): string {
  const s = Math.ceil(ms / 1000);
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const ss = String(s % 60).padStart(2, '0');
  return h > 0 ? `${h}:${String(m).padStart(2, '0')}:${ss}` : `${m}:${ss}`;
}

/** 「〇分前」 */
export function fmtAgo(iso: string | null | undefined): string {
  if (!iso) return '';
  const min = Math.max(0, Math.floor((serverNow() - Date.parse(iso)) / 60000));
  return min < 1 ? 'たった今' : `${min}分前`;
}
